import React, { Component, Fragment } from "react";
import ReactHtmlParser from "react-html-parser";
import Loader from "./Loader";
import { formatTimestamp } from "../../Utils/utils";
import { coins } from "../../Utils/Constants";

const PercentCoin = require("../../assets/media/coins/percent-coin.png");

class MessageItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: props.loaded,
      img_src: props.userIcon || require("./logos/logo.png"),
    };
  }

  componentDidMount() {
    this.setState({ loaded: this.props.loaded });
  }
  getImage = (type) => {
    const { icon, userIcon, territory } = this.props;
    switch (type) {
      case "agency":
        return userIcon || require("./logos/logo.png");
      case "bot":
        return icon;
      case "landlord":
        return require("./logos/landlord_logo.png");
      case "contractor":
        return require("./logos/contractor_logo.png");
      case "shopping_token_bot":
        return PercentCoin;
      case "premier_token_bot":
        return coins[territory || "UK"];
      default:
        return require("./logos/agency_logo.png");
    }
  };
  getType = (type) => {
    if (type !== "user") return "bot";
    return "user";
  };
  render() {
    const { logo } = this.props;
    const { type, message, username, time } = this.props.message;
    const { loaded, img_src } = this.state;

    const messageComponent = `<p>${message}</p><span class="${
      time ? "message__timestamp" : "message__timestamp--hidden"
    }">${formatTimestamp(time)}</span>`;

    return (
      <Fragment>
        <div
          style={
            type === "user"
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  marginBottom: 16,
                  position: "relative",
                  marginRight: 50,
                }
              : {
                  display: "flex",
                  alignSelf: "flex-end",
                  maxWidth: "100%",
                  marginBottom: 16,
                  position: "relative",
                  marginLeft: 50,
                }
          }
        >
          {type === "user" && (
            <div
              className="avatar"
              style={{ backgroundImage: `url(${img_src})` }}
              alt="concierge"
            />
          )}

          <div
            className={`message-item-wrapper ${
              loaded ? "loaded" : ""
            } ${this.getType(type)} `}
          >
            <Loader />
            <p
              className={`message__username`}
              style={{
                left: type === "user" ? 65 : "unset",
                right: type === "user" ? "unset" : "",
              }}
            >
              {username}
            </p>
            <div className={`message ${logo === "bolt" ? "" : "notbolt"}`}>
              {ReactHtmlParser(messageComponent)}
            </div>
          </div>
          {(type === "agency" ||
            type === "landlord" ||
            type === "contractor" ||
            type === "bot" ||
            type === "shopping_token_bot" ||
            type === "premier_token_bot") && (
            <img
              className="avatar"
              src={this.getImage(type)}
              style={{ width: 40, height: 40, marginLeft: 5 }}
              alt="concierge"
            />
          )}
        </div>
      </Fragment>
    );
  }
}

export default MessageItem;



// WEBPACK FOOTER //
// ./src/screens/LiveChat/MessageItem.js